import * as React from 'react';
import {Timeline, Card, CardHeader} from 'framework7-react';
import {getFramework7} from './App';

export class TourTimeline extends React.Component {
    constructor(props, context) {
        super(props, context);
		this.audio = new Audio();
		this.state = {
		    selectedTrack: '',
            isPlaying: false,
        }
    }

    handlePlayClicked() {
        if (this.myThis.state.selectedTrack === this.building.audio) {
			if (this.myThis.state.isPlaying) {
				this.myThis.audio.pause();
			} else {
				this.myThis.audio.play();
			}
			this.myThis.setState(prevState => ({isPlaying: !this.myThis.state.isPlaying}));
		} else {
			this.myThis.audio.src = this.building.audio;
			this.myThis.audio.play();
			this.myThis.setState(prevState => ({selectedTrack: this.building.audio}));
			this.myThis.setState(prevState => ({isPlaying: true}));
		}
    }

    createTimelineItem = (buildingSlug) => {
        let building = this.props.buildings.find((b) => b.slug === buildingSlug);

        let playIcon;
        if (building.audio !== '') {
            let thisBuildingPlaying = this.state.isPlaying && this.state.selectedTrack === building.audio;
            let playClass = "timeline-play-button f7-icons ";
            if (thisBuildingPlaying) {
                playClass += "color-green"
            } else {
                playClass += "color-blue"
            }
            playIcon= <i onClick={this.handlePlayClicked.bind({myThis: this, building: building})}
			 className={playClass}>{thisBuildingPlaying ? 'pause_round_fill' : 'play_round_fill'}</i>;
        } else {
            playIcon= <i onClick={function() {
                getFramework7().alert('Sorry, we do not have an audio track available for this site at this time.', 'No Track Available');
            }} className="timeline-play-button f7-icons color-gray">play_round</i>
        }

        return (
            <div className="timeline-item" key={buildingSlug}>
                <div className="timeline-item-date">
                    {playIcon}
                </div>
                <div className="timeline-item-divider"></div>
                <div className="timeline-item-content tour-building-card">
                    <Card>
                    <div className="timeline-item-title" onClick={() => getFramework7().popup('.popup-' + building.slug)}>
                        <CardHeader>
                            {building.name}
                            <i className="chevron_right f7-icons">chevron_right</i>
                        </CardHeader>
                    </div>
                    </Card>
                </div>
            </div>
         );
    };

    render () {
        return (
            <Timeline>
                {this.props.tour.buildings.map(this.createTimelineItem)}
            </Timeline>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TourTimeline.jsx